import { Chip, Grid, makeStyles, Theme } from "@material-ui/core";
import Autocomplete from "components/Autocomplete";
import TextField from "components/TextField";
import useText from "constants/text";
import { checkReccurenceIntervalDate, NewRequestQuoteContext } from "contexts/RequestQuoteContext";
import { EProductType } from "generated/graphql";
import React from "react";
import { formatDate as DateFormat } from "utils";
import { formatDate, isFieldWithValue } from "../shared/utils";

const useStyles = makeStyles((theme: Theme) => ({
  gridContainer: {
    padding: "3rem 0rem 0rem 0rem",
    width: "50%",
    [theme.breakpoints.down("xs")]: { width: "100%" },
  },
}));

export default function ReschedulingNT() {
  const { requestQuoteNT, requestQuoteDetails, setRequestQuoteNT, setStep } = React.useContext(NewRequestQuoteContext);
  const { text } = useText();
  const styles = useStyles();

  React.useEffect(() => {
    setStep(2)
  })

  React.useEffect(() => {
    if (!isFieldWithValue(requestQuoteNT?.startDate)) {
      setRequestQuoteNT({ ...requestQuoteNT, startDate: formatDate() });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const productsTypeOptions = [
    {
      value: EProductType.Couriers,
      description: text.requestQuote.product_type_courrier,
    },
    {
      value: EProductType.Fragile,
      description: text.requestQuote.product_type_fragile,
    },
    {
      value: EProductType.Food,
      description: text.requestQuote.product_type_food,
    },
    {
      value: EProductType.FreshProducts,
      description: text.requestQuote.product_type_fresh_products,
    },
    {
      value: EProductType.Other,
      description: text.requestQuote.product_type_other,
    },
  ];
  const [filterOptions, setFilterOptions] = React.useState(productsTypeOptions);

  React.useEffect(() => {
    if (requestQuoteNT?.productType) {
      setFilterOptions(
        productsTypeOptions.filter(
          (x) => requestQuoteNT?.productType.findIndex((e: any) => x.value === e?.value || x.value === e) === -1
        )
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requestQuoteNT?.productType]);

  const onChangeDate = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRequestQuoteNT({
      ...requestQuoteNT,
      [event.target.name]: event.target.value,
    });
  };

  const handleChange = (newArray: any) => {
    setRequestQuoteNT({
      ...requestQuoteNT,
      productType: newArray.map((productType: any) => productType?.value || productType),
    });
  };

  const getOptionValueDescription = (option: any) =>
    productsTypeOptions?.find((item) => option?.value === item.value || option === item.value)?.description || "";

  const onChangeInputValue = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRequestQuoteNT({ ...requestQuoteNT, additionnalInfos: event.target.value });
  };
  const handleChangeProduct =(event: any, newValue: any) => {
    handleChange(newValue);
  }

  return (
    <NewRequestQuoteContext.Consumer>
      {({ requestQuoteNT, fieldError }) => (
        <Grid container spacing={5} className={styles.gridContainer}>
          <Grid item xs={12}>
            <Autocomplete
              fullWidth
              multiple
              id="fixed-tags-demo"
              label={text.requestQuote.select_product_type}
              value={requestQuoteNT?.productType}
              onChange={handleChangeProduct}
              options={filterOptions}
              getOptionLabel={(option: any) => option.description}
              renderTags={(tagValue: any, getTagProps: any) =>
                tagValue.map((option: any, index: any) => (
                  <Chip
                    label={getOptionValueDescription(option)}
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...getTagProps({ index })}
                  />
                ))
              }
              error={fieldError && !requestQuoteNT?.productType?.length}
              helperText={fieldError && !requestQuoteNT?.productType?.length ? text.all.this_field_is_required : ""}
            />
          </Grid>
          
          <Grid item xs={12}>
            <TextField
              type="date"
              fullWidth
              label={text.all.execution_date}
              name="startDate"
              id="date"
              value={DateFormat(requestQuoteNT?.startDate, 'YYYY-MM-dd')}
              onChange={onChangeDate}
              inputProps={{ min: formatDate() }}
              error={
                fieldError &&
                isFieldWithValue(requestQuoteNT?.reccurenceType) &&
                (!isFieldWithValue(requestQuoteNT?.startDate) || !checkReccurenceIntervalDate(requestQuoteNT))
              }
              helperText={
                fieldError && isFieldWithValue(requestQuoteNT?.reccurenceType)
                  ? !isFieldWithValue(requestQuoteNT?.startDate)
                    ? text.all.this_field_is_required
                    : !checkReccurenceIntervalDate(requestQuoteNT)
                      ? text.all.intervall_date_error
                      : ""
                  : ""
              }
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label={text.requestQuote.additionnal_details}
              multiline
              fullWidth
              onChange={onChangeInputValue}
              value={requestQuoteNT?.additionnalInfos}
              rows={4}
            />
          </Grid>
        </Grid>
      )}
    </NewRequestQuoteContext.Consumer>
  );
}
